import { get } from "../../service/api";

const GetMerchantActionLog = async (id, query) => {
  try {
    const response = await get(`/merchant/${id}/actionLog?${query}`);
    return response;
  } catch (error) {
    console.error("Error GetMerchantActionLog:", error);
    throw error;
  }
};

export default GetMerchantActionLog;
